export default "__VITE_ASSET__ed9a9f63__"